import React, { useState, useEffect } from "react";
import Layout from "../../layout/DefaultLayout";
import {
  Container,
  Row,
  Col,
  Button,
  Card,
  Form,
  Modal,
  ListGroup,
  InputGroup,
  Spinner,
} from "react-bootstrap";
import {
  FaPlus,
  FaArrowRight,
  FaArrowLeft,
  FaPen,
  FaTrash,
  FaGlasses,
} from "react-icons/fa";
import { FiBook, FiEdit3 } from "react-icons/fi";
import { GoTrash } from "react-icons/go";
import { useNavigate, Link, useLocation } from "react-router-dom";
import "../courses/course.css";
import { AiOutlineLink } from "react-icons/ai";
import { IoMdCheckmarkCircleOutline } from "react-icons/io";
import { Search } from "react-bootstrap-icons";
import Footer from "../../components/Footer";
import Success from "../../components/vendor/Success";
import { useAlerts } from "../../context/AlertContext";
import { useMutation, useQuery, useQueryClient } from "react-query";
import api from "../../utils/helper";
import { useForm } from "react-hook-form";
import AddLink from "./add-module/AddLink";
import ApprovalModal from "./add-module/components/ApprovalModal";
import { useIDsContext } from "../../context/IDsContext";
import Delete from "../../components/Delete";

const users = [
  {
    id: 1,
    name: "Candice Wu",
    company: "@Bajaj Auto",
    avatar: "images/Avatar_3.png",
  },
  {
    id: 2,
    name: "Craig Miles",
    company: "@Bajaj Auto",
    avatar: "images/Avatar_4.png",
  },
  {
    id: 3,
    name: "Cindy Chen",
    company: "@Bajaj Auto",
    avatar: "images/Avatar_5.png",
  },
  {
    id: 4,
    name: "Gordon Aki",
    company: "@candice",
    avatar: "images/Avatar_3.png",
  },
  {
    id: 5,
    name: "Oscar Wills",
    company: "@demi",
    avatar: "images/Avatar_4.png",
  },
];

const AddPrerecordLesson = () => {
  const [showModal, setShowModal] = useState(false);
  const [lessons, setLessons] = useState([]);
  const [lessonName, setLessonName] = useState("");
  const [lessonSummary, setLessonSummary] = useState("");
  const [showLinkModal, setShowLinkModal] = useState(false);
  const [externalLink, setExternalLink] = useState("");
  const [externalLinks, setExternalLinks] = useState([]);
  const [showApprovalModal, setShowApprovalModal] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [showApproved, setShowApproved] = useState(false);
  const [showAssignModal, setShowAssignModal] = useState(false);
  const [editingLesson, setEditingLesson] = useState(null);

  const [showDelete, setShowDelete] = useState(false);
  const [lessonToDelete, setLessonToDelete] = useState("");
  const [lessonNameToDelete, setlessonNameToDelete] = useState("");
  const [selectedModule, setSelectedModule] = useState(null);
  const [lessonAdded, setLessonAdded] = useState(false);
  const [linkCount, setLinkCount] = useState(0); // state to track link count

  const location = useLocation();

  const {
    register,
    handleSubmit,
    reset,
    setValue,
    formState: { errors },
  } = useForm({
    defaultValues: {
      lessonName: "",
      lessonSummary: "",
    },
  });

  const { showSuccess, showError } = useAlerts();
  const queryClient = useQueryClient();

  // const courseId = location?.state?.dataToNavigate?._id;

  const {
    courseID: courseId,
    setLessonID,
    lessonID,
    vendorID,
  } = useIDsContext();

  console.log(location?.state?.dataToNavigate);

  //const handleShowModal = () => setShowModal(true);
  const handleShowModal = () => {
    reset(); // Reset the form every time the modal opens
    setShowModal(true);
  };
  const handleCloseModal = () => {
    setShowModal(false);
    reset(); // Reset form after closing modal to clear the values
    setLessonName("");
    setLessonSummary("");
  };

  const { data, isLoading, error, isSuccess, isError } = useQuery(
    ["lessons", { id: courseId }],
    () => api.get(`/lessons/course/${courseId}`)
  );

  const handleDeleteLesson = (lessonID, lessonName) => {
    // deleteLessonMutation.mutate(lessonID)
    setShowDelete(true);
    setLessonToDelete(lessonID);
    setlessonNameToDelete(lessonName);
  };

  const handleAddExternalLink = (lesson) => {
    const firstModule = lesson.modules[0];
    setSelectedModule(firstModule);
    if (lesson.modules && lesson.modules.length > 0) {
      setSelectedModule(lesson.modules[0]);
    } else {
      setSelectedModule(null);
    }
    setLessonID(lesson._id);
    setShowLinkModal(true);
  };

  const handleLinkCountUpdate = (count) => {
    setLinkCount(count); // update the link count
  };

  const handleCloseLinkModal = () => {
    setShowLinkModal(false);
    setExternalLink("");
  };

  const handleLinkSubmit = () => {
    if (externalLink.trim() === "") {
      alert("URL is required.");
      return;
    }
    // Add the external link to the lesson content
    setExternalLinks([...externalLinks, externalLink]);
    setExternalLink("");
    handleCloseLinkModal();
  };

  const handleDeleteLink = (index) => {
    const updatedLinks = externalLinks.filter((_, i) => i !== index);
    setExternalLinks(updatedLinks);
  };

  const handleSelectUser = (user) => {
    setSelectedUsers((prev) =>
      prev.includes(user.id)
        ? prev.filter((id) => id !== user.id)
        : [...prev, user.id]
    );
  };

  const addLessonMutation = useMutation(
    (lesson) => api.post("/lessons", lesson, "add-lesson"),
    {
      onSuccess: (response) => {
        queryClient.invalidateQueries(["lessons", { id: courseId }]);
        handleCloseModal();
        setLessonAdded(true); // ✅ Set the flag
        showSuccess(response.data?.message || "Lesson added successfully!");
      },
      onError: (error) => {
        // Handle API errors
        console.error("Error adding lesson:", error);
        showError(
          error.response?.data?.message ||
            "Error adding lesson. Please try again."
        );
      },
    }
  );

  // Mutation for updating a lesson
  const updateLessonMutation = useMutation(
    ({ lessonId, lessonData }) =>
      api.put(`/lessons/${lessonId}`, lessonData, "update-lesson"),
    {
      onSuccess: (response) => {
        queryClient.invalidateQueries(["lessons", { id: courseId }]);
        handleCloseModal();
        showSuccess(response.data?.message || "Lesson updated successfully!");
      },
      onError: (error) => {
        console.error("Error updating lesson:", error);
        showError(
          error.response?.data?.message ||
            "Error updating lesson. Please try again."
        );
      },
    }
  );

  const onSubmit = (data) => {
    console.log("LESSON");
    // Prepare data for API
    const lessonData = {
      name: data.lessonName,
      summary: data.lessonSummary,
      course: courseId, // Assuming courseId might be passed in location state
      type: "prerecorded",
    };

    if (editingLesson) {
      // Update existing lesson
      updateLessonMutation.mutate({
        lessonId: editingLesson._id,
        lessonData,
      });
    } else {
      // Add new lesson
      addLessonMutation.mutate(lessonData);
    }
  };

  useEffect(() => {
    if (!showModal) {
      reset(); // resets form when modal is closed
      setEditingLesson(null); // reset editing state
    }
  }, [showModal]);

  const deleteLessonMutation = useMutation(
    (lessonID) => api.delete(`/lessons/${lessonID}`, "delete-lesson"),
    {
      onSuccess: (response) => {
        queryClient.invalidateQueries(["lessons", { id: courseId }]);
        showSuccess(response.data?.message || "Lesson deleted successfully!");
      },
      onError: (error) => {
        // Handle API errors
        console.error("Error deleting lesson:", error);
        showError(
          error.response?.data?.message ||
            "Error deleting lesson. Please try again."
        );
      },
    }
  );

  const handleEdit = (lesson) => {
    //Edit Lesson
    setEditingLesson(lesson);
    setValue("lessonName", lesson.name);
    setValue("lessonSummary", lesson.summary);
    setShowModal(true);
  };

  return (
    <Layout>
      <div className="bgNav d-block d-lg-none pb-5 px-1 position-relative">
        <div>
          <h2 className="heading mb-0 px-3">
            <Link to="/courses" className="linkHref">
              <span className="linkHref">Courses</span>{" "}
            </Link>
            <FaArrowRight color="#fff" />
            <Link to="/courses" className="linkHref">
              {" "}
              <span className="linkHref">Pre-recorded</span>
            </Link>{" "}
            <FaArrowRight color="#fff" />
            <Link to="/add-course" className="linkHref">
              <span className="linkHref">Add New</span>
            </Link>
            <span className=" text-light fw-bol">
              {" "}
              <FaArrowRight /> Leasons
            </span>
          </h2>
        </div>
        <div className="d-flex justify-content-center px-2 mt-3">
          <Button variant="light" className="me-2 btn-course ">
            Cancel
          </Button>

          <Button variant="light" className="me-2 btn-course ">
            Save Draft{" "}
          </Button>
        </div>
      </div>
      <Container
        fluid
        className="main-container vendor-container mt-0 mt-md-4 ps-auto ps-md-0"
      >
        <Card className="form-card">
          <Card.Header className="heading d-none d-lg-block">
            <div className="d-flex justify-content-between align-items-center">
              <div className="d-flex gap-2 align-items-center">
                <h2 className="text-muted venhead mb-0">
                  <Link to="/courses" className="linkHref">
                    <span>Courses</span>{" "}
                  </Link>
                  <FaArrowRight />
                  <Link to="/courses" className="linkHref">
                    {" "}
                    <span>Pre-recorded</span>
                  </Link>{" "}
                  <FaArrowRight />
                  <Link to="/add-course" className="linkHref">
                    <span>Add New</span>
                  </Link>
                  <span className="text-dark fw-bold">
                    {" "}
                    <FaArrowRight /> Leasons
                  </span>
                </h2>
              </div>
              <div>
                <Button variant="outline-secondary" className="me-2 btn-sec">
                  Cancel
                </Button>
                <Button variant="outline-secondary" className="me-2 btn-sec">
                  Save Draft
                </Button>
              </div>
            </div>
          </Card.Header>
          <Card.Body className="mobile-form">
            <Form
              className={`p-2 d-flex flex-column ${
                lessons.length === 0 ? "w-lession-m" : "w-lession-w"
              }`}
            >
              <Row className="d-flex flex-column gap-3">
                {!lessonAdded && (
                  <Col>
                    <div className="text-center">
                      <h3 className="textLesson">
                        Add new lessons or course modules
                      </h3>
                    </div>
                  </Col>
                )}
                <Col className="d-flex justify-content-center">
                  <Button
                    variant="outline-secondary"
                    className="me-2 mb-3"
                    onClick={handleShowModal}
                  >
                    <FaPlus /> Add New Lessons
                  </Button>
                </Col>
              </Row>

              {/* Display Saved Lessons */}
              <Container className="lesson-con">
                <Row className="d-flex flex-column gap-3">
                  {isLoading ? (
                    <Spinner size="md" />
                  ) : !isLoading && data?.data?.data?.length === 0 ? (
                    <p className="text-center my-5 text-black">
                      Lessons not found!
                    </p>
                  ) : !isSuccess && isError ? (
                    <p className="text-center my-5 text-danger">
                      {error.message}
                    </p>
                  ) : (
                    data?.data?.data?.map((lesson, index) => (
                      <Col md={12} key={index} className="mb-4">
                        <Card className="p-3 shadow-sm lessonList">
                          <div className="d-flex justify-content-between">
                            <div>
                              <h6 className="mb-1">
                                {lesson.name}{" "}
                                <FiEdit3
                                  className="ms-2"
                                  color="#60B1FF"
                                  onClick={() => handleEdit(lesson)}
                                />
                              </h6>
                              {/* Display count of YouTube links */}
                              <p className="text-muted mb-0">
                                {/* {lesson?.modules?.reduce(
                                  (total, module) =>
                                    total +
                                    (module.preRecordLinks?.length || 0),
                                  0
                                )} */}
                                {linkCount} YouTube links
                              </p>
                            </div>
                            <div className="d-flex gap-2">
                              <Button
                                color="#60B1FF"
                                size="sm"
                                className="btnPluss"
                                onClick={() => handleAddExternalLink(lesson)}
                                style={
                                  lesson?.modules?.length === 0
                                    ? {} // No additional styles for the plus icon
                                    : {
                                        cursor: "pointer",
                                        backgroundColor: "#fff",
                                        color: "#60B1FF",
                                        borderRadius: "30px",
                                        boxShadow:
                                          "0px 4px 10px rgba(0, 0, 0, 0.1)",
                                        width: "48px",
                                        height: "48px",
                                      } // Styles for the edit icon
                                }
                              >
                                {lesson?.modules?.length === 0 ? (
                                  <FaPlus />
                                ) : (
                                  <FiEdit3 />
                                )}
                              </Button>
                              <Button
                                variant="outline-danger"
                                size="sm"
                                onClick={() =>
                                  handleDeleteLesson(lesson._id, lesson.name)
                                }
                                className="btnTrashs"
                              >
                                <GoTrash />
                              </Button>
                            </div>
                          </div>

                          {/* Display External Links */}
                          {lesson?.modules?.[0]?.preRecordLinks?.length > 0 && (
                            <ListGroup className="mt-3">
                              {lesson.modules[0].preRecordLinks.map(
                                (link, i) => (
                                  <ListGroup.Item
                                    key={i}
                                    className="d-flex justify-content-between align-items-center"
                                  >
                                    <a
                                      href={link.link}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                      className="text-primary"
                                    >
                                      {link.link}
                                    </a>
                                  </ListGroup.Item>
                                )
                              )}
                            </ListGroup>
                          )}
                        </Card>
                      </Col>
                    ))
                  )}
                </Row>
              </Container>

              <Row>
                {/* Back and Conditional Send for Approval Buttons */}
                <div className="text-start btnApproval w-lession-m px-4">
                  <Link to="/add-prerecord" style={{ color: "transparent" }}>
                    <Button
                      variant="outline-secondary"
                      className="me-2 d-flex align-items-center gap-2"
                    >
                      <FaArrowLeft />
                      Back
                    </Button>
                  </Link>
                  {data && (
                    <Button
                      variant="outline-primary btn-sec w-auto"
                      className="float-end"
                      // disabled
                      onClick={() => setShowAssignModal(true)}
                    >
                      Send for Approval
                    </Button>
                  )}
                  {/* {data && (
                    <Button
                      variant="outline-primary btn-sec"
                      className="float-end"
                      // disabled
                      onClick={() => setShowAssignModal(true)}
                    >
                      Send for Approval
                    </Button>
                  )} */}
                </div>
              </Row>
            </Form>
          </Card.Body>
        </Card>
      </Container>

      <AddLink
        show={showLinkModal}
        lessonID={lessonID}
        close={() => setShowLinkModal(false)}
        setLinkCount={handleLinkCountUpdate} // pass the function to update count
      />

      {/* Modal for Lesson Details */}
      <Modal show={showModal} onHide={handleCloseModal} centered>
        <Modal.Body className="w-auto">
          <div className="">
            <img src="/images/lesson.png" height={40} width={40} />
          </div>
          <Modal.Title className="lessonDetails mb-4">
            Lesson details
          </Modal.Title>
          <Form onSubmit={handleSubmit(onSubmit)}>
            <Form.Group className="mb-3" controlId="lessonName">
              <Form.Control
                type="text"
                placeholder="Lesson name"
                isInvalid={!!errors.lessonName}
                {...register("lessonName", {
                  required: "Lesson name is required",
                  minLength: {
                    value: 3,
                    message: "Lesson name must be at least 3 characters",
                  },
                })}
              />
              {errors.lessonName && (
                <Form.Control.Feedback type="invalid">
                  {errors.lessonName.message}
                </Form.Control.Feedback>
              )}
            </Form.Group>

            <Form.Group className="mb-3" controlId="lessonSummary">
              <Form.Control
                as="textarea"
                rows={3}
                placeholder="Lesson summary"
                isInvalid={!!errors.lessonSummary}
                {...register("lessonSummary", {
                  required: "Lesson summary is required",
                })}
              />
              {errors.lessonSummary && (
                <Form.Control.Feedback type="invalid">
                  {errors.lessonSummary.message}
                </Form.Control.Feedback>
              )}
            </Form.Group>

            <div className="d-flex">
              <Button
                variant="outline-secondary"
                className="me-2 btn-sec-v"
                onClick={handleCloseModal}
                type="button"
              >
                Cancel
              </Button>
              <Button
                type="submit"
                color="#60B1FF"
                className="btn-sec-v"
                disabled={addLessonMutation.isLoading}
              >
                {addLessonMutation.isLoading ? (
                  <Spinner animation="border" size="sm" />
                ) : (
                  "Save"
                )}
              </Button>
            </div>
          </Form>
        </Modal.Body>
      </Modal>

      <ApprovalModal
        show={showAssignModal}
        onHide={() => setShowAssignModal(false)}
        id={vendorID}
        courseID={courseId}
        onApprove={() => {
          setShowAssignModal(false);
        }}
      />

      <Delete
        show={showDelete}
        close={() => setShowDelete(false)}
        handleDelete={() => {
          deleteLessonMutation.mutate(lessonToDelete);
          setShowDelete(false);
        }}
        title="Delete Lesson"
        name={lessonNameToDelete}
      />

      <div className="d-none d-lg-block">
        <Footer />
      </div>
    </Layout>
  );
};

export default AddPrerecordLesson;
